import React from "react"
import FeesPlastics from "../environment/en/FeesPlastics"

const Fees = props => {
  if (props.type === "plastics") {
    return <FeesPlastics />
  } else {
    return <div></div>
  }
}

export default Fees
